import axios from "../../../interceptors";
import { GET_UPLOAD_PDF,DELETE_UPLOAD_PDF } from "../../../constants/router";

export const getUploadPdf = () => axios.get(GET_UPLOAD_PDF);
export const deletePDF = (id='') => axios.delete(`${DELETE_UPLOAD_PDF}/${id}`);

